import React, { useState, useMemo } from 'react';
import { Button, Upload } from 'antd';
import { beforePicUpload } from '@/common/utils';
import { customRequest } from '@/common/utils/image-utils/custom-request';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';

const ActivityDemoImg = (props) => {
  const { value, onChange } = props;
  const [loading, setLoading] = useState(false); // 图片上传的加载状态
  const imageName = useMemo(() => {
    if (!value || !value.demoImgName) return '';
    return value.demoImgName;
  }, [value]); // 图片链接

  // const uploadButton = <div>{loading ? <LoadingOutlined /> : <PlusOutlined />}</div>;

  function handlePicChange(info) {
    // 本地上传的图片
    if (info.file.status === 'uploading') {
      setLoading(true);
      return;
    }
    if (info.file.status === 'done') {
      setLoading(false);
      onChange({ demoImgUrl: info.file.response.url, demoImgName: info.file.name });
    }
  }
  const uploadProp = {
    accept: '.png,.jpg,.jpeg',
    name: 'demoImg',
    className: 'avatar-uploader',
    showUploadList: false,
    beforeUpload: (file) => {
      return beforePicUpload(file, null, 2 * 1024, null);
    },
    customRequest: customRequest,
    onChange: handlePicChange,
  };

  return (
    <div className="demo-img-upload">
      {imageName && <a style={{ marginRight: 8 }}>{imageName}</a>}
      <Upload {...uploadProp} listType="text">
        <Button type="primary" loading={loading}>
          {imageName ? '重新上传' : '上传图片'}
        </Button>
      </Upload>
      <div className="upload-extra">
        <span className="tip">大小3MB以内；支持扩展名png、jpg、jpeg</span>
      </div>
    </div>
  );
};

export default ActivityDemoImg;
